/* Flamengo - client-side vertaling van Judge.me reviewteksten (NL -> de/en/fr).
   Woordenboek: assets/fl-review-i18n*.json, sleutel = genormaliseerde brontekst (titel, alinea of hele body).
   Werkt op server-gerenderde en client-side (API/carousel/load-more/klonen) Judge.me-HTML. */
(function () {
  'use strict';
  var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (!htmlLang || htmlLang.indexOf('nl') === 0) return;
  var lang = htmlLang.slice(0, 2);
  if (lang !== 'de' && lang !== 'en' && lang !== 'fr') return;

  var script = document.currentScript;
  var src = (script && script.getAttribute('data-dict')) || window.FL_REVIEW_I18N_DICT || '';
  var urls = (Array.isArray(src) ? src : String(src).split(',')).map(function (u) { return u.trim(); }).filter(Boolean);
  if (!urls.length) return;

  var dict = Object.create(null);
  var byPrefix = Object.create(null);   // eerste 40 tekens -> [sleutels]
  var PFX = 40;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, NOSCRIPT: 1, TEMPLATE: 1, SVG: 1 };
  var SCOPE = '[class*="jdgm"],[class*="review"],[class*="Review"],[class*="testimonial"]';
  var MORE = /^(lees meer|meer lezen|lees verder|read more|weiterlesen|mehr lesen|lire la suite|voir plus|\.\.\.|…|meer|more|mehr|plus)$/i;
  var ELL = /\s*(…|\.{3})\s*$/;

  function norm(s) { return String(s).replace(/\s+/g, ' ').trim(); }

  function tr(key) {
    var e = dict[key];
    return e && typeof e[lang] === 'string' ? e[lang] : null;
  }

  // tekst van element waarbij <br> en blokgrenzen als spatie tellen
  function textOf(el) {
    var out = [];
    (function walk(n) {
      for (var c = n.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3) out.push(c.nodeValue);
        else if (c.nodeType === 1) {
          if (c.tagName === 'BR') out.push(' ');
          else if (!SKIP[c.tagName]) { out.push(' '); walk(c); out.push(' '); }
        }
      }
    })(el);
    return norm(out.join(''));
  }

  // beste sleutel bij een (mogelijk afgekapte of licht afwijkende) tekst
  function fuzzy(text, truncated) {
    if (text.length < PFX) return null;
    var cands = byPrefix[text.slice(0, PFX).toLowerCase()];
    if (!cands) return null;
    var best = null, bestD = Infinity;
    for (var i = 0; i < cands.length; i++) {
      var k = cands[i];
      if (truncated) {
        if (k.length < text.length || k.slice(0, text.length).toLowerCase() !== text.toLowerCase()) continue;
        var d0 = k.length - text.length;
        if (d0 < bestD) { best = k; bestD = d0; }
      } else {
        var d = Math.abs(k.length - text.length);
        if (d <= Math.max(3, k.length * 0.12) && d < bestD) { best = k; bestD = d; }
      }
    }
    return best;
  }

  function cut(t, ratio) {
    t = norm(t);
    var n = Math.max(20, Math.round(t.length * ratio));
    if (n >= t.length) return t;
    var s = t.slice(0, n), sp = s.lastIndexOf(' ');
    if (sp > n * 0.7) s = s.slice(0, sp);
    return s.replace(/[\s,.;:!?-]+$/, '') + '…';
  }

  function setLines(el, txt) {
    var lines = txt.split('\n');
    while (el.firstChild) el.removeChild(el.firstChild);
    for (var i = 0; i < lines.length; i++) {
      if (i) el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(lines[i]));
    }
  }

  function mark(el) { el.setAttribute('data-fl-i18n', lang); }

  // Probeer volledige tekst (exact of fuzzy); retourneert vertaling of null
  function resolve(text) {
    var t = tr(text);
    if (t !== null) return { t: t, key: text };
    var k = fuzzy(text, false);
    if (k) return { t: tr(k), key: k };
    return null;
  }

  // Element met alleen <p>/<br>-kinderen: hele body als één sleutel
  function tryContainer(el) {
    var kids = el.children, nP = 0;
    if (!kids.length) return false;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].tagName === 'P') nP++;
      else if (kids[i].tagName !== 'BR') return false;
    }
    if (nP < 2) return false;
    var text = textOf(el);
    var r = resolve(text);
    if (!r || r.t === null || norm(r.t) === text) return false;
    var paras = r.t.split(/\n/);
    while (el.firstChild) el.removeChild(el.firstChild);
    var p = document.createElement('p');
    setLines(p, paras.join('\n'));
    el.appendChild(p);
    mark(el);
    return true;
  }

  function translateLeaf(el) {
    // tekstnodes + <br>, eventueel één 'lees meer'-element
    var moreEl = null;
    for (var c = el.firstElementChild; c; c = c.nextElementSibling) {
      if (c.tagName === 'BR') continue;
      if (!moreEl && c.children.length === 0 && MORE.test(norm(c.textContent))) { moreEl = c; continue; }
      return;
    }
    var parts = [];
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) parts.push(n.nodeValue);
      else if (n.nodeType === 1 && n.tagName === 'BR') parts.push(' ');
    }
    var text = norm(parts.join(''));
    if (!text || text.length < 2) return;

    var r = resolve(text);
    if (r && r.t !== null) {
      if (norm(r.t) === text) return;
      if (moreEl) { replaceText(el, r.t, moreEl); } else setLines(el, r.t);
      mark(el); return;
    }

    // "Avis pour: <product>" - alleen deel na dubbele punt
    var m = text.match(/^(.{1,60}?:\s*)(.+)$/);
    if (m && !moreEl) {
      var t2 = tr(m[2]);
      if (t2 !== null && norm(t2) !== m[2] && t2.indexOf('\n') === -1) {
        for (var x = el.firstChild; x; x = x.nextSibling) {
          if (x.nodeType === 3 && x.nodeValue.indexOf(':') !== -1) {
            var idx = x.nodeValue.indexOf(':');
            x.nodeValue = x.nodeValue.slice(0, idx + 1) + ' ' + t2;
            for (var y = x.nextSibling; y;) { var nx = y.nextSibling; if (y.nodeType === 3 || y.tagName === 'BR') el.removeChild(y); y = nx; }
            mark(el); return;
          }
        }
      }
    }

    // Afgekapte tekst ("…", "...", of met 'lees meer')
    var truncated = ELL.test(text) || !!moreEl;
    if (truncated) {
      var pre = norm(text.replace(ELL, ''));
      var k = pre.length >= PFX ? fuzzy(pre, true) : null;
      if (k) {
        var full = tr(k);
        if (full !== null && norm(full) !== k) {
          var out = cut(full, pre.length / k.length);
          if (moreEl) replaceText(el, out, moreEl); else setLines(el, out);
          mark(el);
        }
      }
    }
  }

  // vervang tekstnodes/br vóór moreEl, laat moreEl staan
  function replaceText(el, txt, moreEl) {
    for (var n = el.firstChild; n;) {
      var nx = n.nextSibling;
      if (n !== moreEl && (n.nodeType === 3 || (n.nodeType === 1 && n.tagName === 'BR'))) el.removeChild(n);
      n = nx;
    }
    var lines = norm(txt.replace(/\n/g, ' ')) + ' ';
    el.insertBefore(document.createTextNode(lines), moreEl);
  }

  function visit(el) {
    if (SKIP[el.tagName] || el.isContentEditable) return;
    // snelle structuurcheck: alleen elementen met tekst/br/p/1 klein kind zijn kandidaat
    var kids = el.children, ok = true, nonP = 0;
    for (var i = 0; i < kids.length; i++) {
      var tg = kids[i].tagName;
      if (tg === 'BR' || tg === 'P') continue;
      if (++nonP > 1 || kids[i].children.length) { ok = false; break; }
    }
    if (!ok) return;
    if (el.getAttribute('data-fl-i18n') === lang && el.__flDone === el.textContent) return;
    var inScope = el.closest ? el.closest(SCOPE) : null;
    if (!inScope) {
      // buiten review-context alleen lange, unieke teksten (>= 40 tekens)
      var tx = norm(el.textContent);
      if (tx.length < PFX) return;
    }
    if (tryContainer(el)) { el.__flDone = el.textContent; return; }
    translateLeaf(el);
    if (el.getAttribute('data-fl-i18n') === lang) el.__flDone = el.textContent;
  }

  var running = false;
  function run(root) {
    running = true;
    try {
      root = root && root.querySelectorAll ? root : document.body;
      if (!root) return;
      if (root.nodeType === 1 && root !== document.body) visit(root);
      var list = root.querySelectorAll('*');
      // ouders eerst (containers), daarna kinderen; kinderen van vervangen container zijn al nieuw
      for (var i = 0; i < list.length; i++) if (list[i].isConnected !== false) visit(list[i]);
    } catch (e) { /* nooit de pagina breken */ }
    running = false;
  }

  var pending = [], timer = null;
  function schedule(node) {
    pending.push(node);
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      var nodes = pending; pending = [];
      var seen = [];
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.nodeType === 3) n = n.parentNode;
        if (!n || n.nodeType !== 1 || !n.isConnected) continue;
        if (seen.indexOf(n) === -1) { seen.push(n); run(n); }
      }
    }, 80);
  }

  function start() {
    run(document.body);
    if (!('MutationObserver' in window) || !document.body) return;
    new MutationObserver(function (muts) {
      if (running) return;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') schedule(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) schedule(m.addedNodes[j].nodeType === 3 ? m.target : m.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // JSON-object of tekstformaat: records gescheiden door '§', velden 'nl|de|en|fr', regeleinde als '⏎'
  function parseDict(txt) {
    txt = String(txt || '').replace(/^﻿/, '');
    if (/^\s*\{/.test(txt)) return JSON.parse(txt);
    var out = {}, recs = txt.split('§'), L = ['de', 'en', 'fr'];
    for (var i = 0; i < recs.length; i++) {
      var f = recs[i].split('|');
      if (f.length < 2 || !f[0]) continue;
      var e = {};
      for (var j = 0; j < 3; j++) if (f[j + 1]) e[L[j]] = f[j + 1].replace(/⏎/g, '\n');
      out[f[0]] = e;
    }
    return out;
  }

  Promise.all(urls.map(function (u) {
    return fetch(u, { credentials: 'omit' }).then(function (r) { return r.ok ? r.text() : ''; }).then(parseDict).catch(function () { return {}; });
  })).then(function (parts) {
    parts.forEach(function (p) {
      for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) {
        dict[k] = p[k];
        if (k.length >= PFX) { var pk = k.slice(0, PFX).toLowerCase(); (byPrefix[pk] = byPrefix[pk] || []).push(k); }
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  });
})();
